import React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";

const useStyles = makeStyles()({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "left",
    width: "100%",
    padding: "0px 15px",
    textAlign: "left",
    minHeight: "250px",
  },
  inputLabelGrid: {
    alignSelf: "center",
  },
  inputLabel: {
    fontSize: "16px",
    fontWeight: "Bold",
    display: "inline-flex",
  },
});

export default function Mapping({
  claimLoginId,
  setClaimLoginId,
  claimEmail,
  setClaimEmail,
  claimFirstname,
  setClaimFirstname,
  claimLastname,
  setClaimLastname,
  claimValues,
}) {
  const { classes } = useStyles();

  return (
    <Box sx={{ width: "100%" }} component="form" className={classes.formContainer}>
      <Grid container spacing={2} style={{ marginTop: "10px" }}>
        <Grid className={classes.inputLabelGrid} size={3}>
          <InputLabel className={classes.inputLabel}> Login ID* : </InputLabel>
        </Grid>
        <Grid size={9}>
          <TextField
            margin="dense"
            fullWidth
            label="Attribute Claim"
            variant="outlined"
            value={claimLoginId}
            onChange={(e) => setClaimLoginId(e.target.value)}
            required
            select
          >
            {claimValues.map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid className={classes.inputLabelGrid} size={3}>
          <InputLabel className={classes.inputLabel}> Email ID* : </InputLabel>
        </Grid>
        <Grid size={9}>
          <TextField
            margin="dense"
            fullWidth
            label="Attribute Claim"
            variant="outlined"
            value={claimEmail}
            onChange={(e) => setClaimEmail(e.target.value)}
            required
            select
          >
            {claimValues.map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid className={classes.inputLabelGrid} size={3}>
          <InputLabel className={classes.inputLabel}> First Name* : </InputLabel>
        </Grid>
        <Grid size={9}>
          <TextField
            margin="dense"
            fullWidth
            label="Attribute Claim"
            variant="outlined"
            value={claimFirstname}
            onChange={(e) => setClaimFirstname(e.target.value)}
            required
            select
          >
            {claimValues.map((value, i) => (
              <MenuItem key={i} value={value}>
                {value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid className={classes.inputLabelGrid} size={3}>
          <InputLabel className={classes.inputLabel}> Last Name* : </InputLabel>
        </Grid>
        <Grid size={9}>
          <TextField
            margin="dense"
            fullWidth
            label="Attribute Claim"
            variant="outlined"
            value={claimLastname}
            onChange={(e) => setClaimLastname(e.target.value)}
            required
            select
          >
            {claimValues.map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Box>
  );
}
